import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
// import { environment } from 'src/environments/environment.prod';
// import { EnvLoaderService } from 'src/environments/environmentLoader.service';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable()
export class AuthGuardKeycloak extends KeycloakAuthGuard {
  protected router: Router;
  protected keycloakAngular: KeycloakService;

  constructor() {
    const router = inject(Router);
    const keycloakAngular = inject(KeycloakService);

    super(router, keycloakAngular);

    this.router = router;
    this.keycloakAngular = keycloakAngular;
  }

  async isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.authenticated) {
      const parsedUrl = new URL(document.location.href);
      const baseUrl = parsedUrl.origin;
      this.keycloakAngular.login({ redirectUri: baseUrl + state.url });
      return false;
    }
    const requiredRoles = route.data['roles'];
    let granted = false;
    if (!requiredRoles || requiredRoles.length === 0) {
      granted = true;
    } else {
      for (const requiredRole of requiredRoles) {
        if (this.roles.indexOf(requiredRole) > -1) {
          granted = true;
          break;
        }
      }
    }

    if (granted === false) {
      this.router.navigate(['/']);
    }
    return granted;
  }
}
